import {WarningOutlined} from '@ant-design/icons';
import {StopOutlined} from '@ant-design/icons/lib';
import moment from 'moment';
import React from 'react';
import {AccountFieldsFragment, AccountStatus, Maybe} from '../../api/generated';
import {AccountStatusTag, Stack} from '../../components';
import {StatusTag} from '../../components/StatusTag';
import {checkFromAndorra} from '../../lib/accountUtils';
import {colors} from '../../lib/colors';

type Props = {
  account?: Maybe<AccountFieldsFragment>;
};

export const StatusTags: React.FC<Props> = ({account}) => {
  if (!account) return null;
  const isFromAndorra = checkFromAndorra(account);

  return (
    <Stack gutter={12}>
      <AccountStatusTag account={account} />
      {account.churned && (
        <StatusTag style={{marginLeft: 8}} color={colors.error}>
          Churned <WarningOutlined />
        </StatusTag>
      )}
      {account.blocked && (
        <StatusTag style={{marginLeft: 8}} color={colors.error}>
          Blocked <StopOutlined />
        </StatusTag>
      )}
      {account.test && <StatusTag color={colors.yellow}>TEST</StatusTag>}
      {[AccountStatus.PENDING_REVIEW, AccountStatus.NOT_CONFIGURED].includes(account.status) &&
        account.approvedAt && (
          <StatusTag color={colors.yellow}>
            Approved {moment(account.approvedAt).fromNow()}
          </StatusTag>
        )}
      {account.payoutTerms?.suspended && (
        <StatusTag color={colors.error}>
          Payouts suspended <WarningOutlined />
        </StatusTag>
      )}
      {!isFromAndorra && !account?.dynamicBilling && (
        <StatusTag color={colors.yellow}>
          Dynamic billing disabled <WarningOutlined />
        </StatusTag>
      )}
    </Stack>
  );
};
